<template>
  <div class="info-content">
    <div class="content-title">
      风月扫盲
    </div>
    <div class="content-title-1">
      一、常见名词解释
    </div>
    <p class="content-dec">
      1、【SPA】：原指“水疗”，现含义发生变化，特指“全身推油”（即使没有推油，完全是干推）。SPA一般带有各种调情，另按价位各种释放方式（手推、X推、臀推、YIN推等），也就是“半套”。SPA是目前最流行的，各种类型的会所纷纷转型为SPA会所，即使没转型的也纷纷推出SPA服务。SPA的花样也越来越多，逐渐融入水磨、拉丝、丝足等等。
      <br />
      2、【半套】：指没有“大活”，但除了“大活”以外的，可以各种推、各种玩。现在基本上没有半套这个说法了，都转型为SPA了。
      <br />3、【小项】：指手推。【中项】：介于手推和大活之间的各种推。【大项】：也就是大活。
      <br />
      4、【桑拿】：原指洗澡，现在含义发生变化，特指“莞式服务”。时间一般为100-120分钟，价格一般1000以上（地级市）-2000（大城市）。桑拿一般都是在星级酒店。
      <br />
      5、【丝足】：指突出丝袜特色的服务。以前流行“丝足按摩”，后来转变为“丝足SPA”，现在纯粹的丝足会所不流行了，而是SPA会所夹带丝足项目。
      <br />
      6、【快餐】：十几分钟解决的那种。价格一般200（普通地级市）-500（大城市）。【全套】：前面多个KH或者XT，在快餐的基础上加一两百块钱（和桑拿的项目完全没办法比）
      <br />
      7、【外围】：有两种意思。①指上门服务的，相对高端点，价格贵点的那种（原本是那种未能进入模特圈、演艺圈的那部分人，后来什么人都自称外围）；②负责给酒店桑拿拉客的，非内部人员，以的士司机居多。。
      <br />8、【家庭式会所】：指在小区内的那种会所，相对比较隐私（会所无非就是四种：①酒店式（租赁场地、自行开房）；②门店式；③家庭式；④上门式。
      <br />
      总的来说，现在花样越来越多，价格越来越贵。
    </p>
    <div class="content-title-1">
      二、电话探路技巧
    </div>
    <p class="content-dec">
     面对一家你从未去过的店，肯定先要打电话询问一番。但在电话中，店家往往支支吾吾、语焉不详。那么，怎么从电话中打探出尽可能多的信息呢？
     <br />
     第1步：你们有什么服务项目？
     <br />
     第2步：有推油没？
     <br />
     第3步：是全身推油吗？
     <br />
     第4步：敏感部位推不推？
    </p>
    <div class="content-title-1">
     三、关于本表说明
    </div>
    <p class="content-dec">
     1、颜色。蓝色代表丝足会所，绿色代表上门的或者桑拿、外围等，白色代表其他类型会所，以SPA为主。黄色代表本表推荐的。
     <br />
     2、本表实时更新，如果暂时没有找到心仪的会所，也不要灰心，各一段时间再来找我索要最新资料，说不定就会有惊喜了。
    </p>
    <div class="content-title-1">
     更多福利关注微信公众号：今天很无聊
    </div>
  </div>
</template>
<script>
export default {
    name:'info'
};
</script>
<style scoped>
.info-content{
    width: 100%;
    padding: 15px 15px;
    box-sizing: border-box;
}
@media only screen and (min-width: 1025px) {
  .content-title {
    width: 100%;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 30px;
    font-weight: 600;
    color: #000;
  }
  .content-dec{
    width: 100%;
    text-align: left;
    margin: 25px 0px;
    font-size: 16px;
    text-align: left;
    color: #000;
  }
  .content-title-1 {
    width: 100%;
    font-size: 16px;
    margin: 10px 0 0 0;
    line-height: 34px;
    text-align: left;
    font-weight: 600;
    color: rgb(255, 0, 0);
  }
}
@media only screen and (max-width: 1024px) {
  
  .content-title {
    width: 100%;
    font-size: 20px;
    line-height: 34px;
    font-weight: 600;
    color: #000;
  }
  .content-title-1 {
    width: 100%;
    font-size: 15px;
    margin: 10px 0 0 0;
    line-height: 34px;
    text-align: left;
    font-weight: 600;
    color: rgb(255, 0, 0);
  }
  .content-dec{
    width: 100%;
    margin: 0px 0 0 0px;
    font-size: 12px;
    text-align: left;
    color: #000;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/info.vue